import React from 'react';
import { bool, node, oneOf, string } from 'prop-types';

import { MdError, MdInfo, MdWarning } from 'react-icons/md';

import styled from 'styled-components/macro';
import { baseSpacing, colors, radius } from 'css/constants';

const IconPrimitive = styled.svg`
  flex-shrink: 0;
  margin-right: ${baseSpacing / 4}px;
  font-size: 1.5rem;
`;

const MessagePrimitive = styled.div`
  display: block;
  align-items: start;
  flex-grow: 1;
  padding: ${baseSpacing / 3}px;
  border-radius: ${radius}px;
  color: #fff;
  background-color: ${({ backgroundColor }) => backgroundColor};
  text-shadow: 1px 1px rgb(0 0 0 / 10%);
  margin-bottom: ${({ withMarginBottom }) =>
    withMarginBottom ? `${baseSpacing / 2}px` : '0'};
`;

/** Formatted message of one of three types: info, warning or error */
function Message({ className, children, type, withMarginBottom }) {
  let backgroundColor;
  let icon;

  if (type === Message.types.ERROR) {
    backgroundColor = colors.red;
    icon = <IconPrimitive as={MdError} />;
  } else if (type === Message.types.WARNING) {
    backgroundColor = colors.orange;
    icon = <IconPrimitive as={MdWarning} />;
  } else {
    backgroundColor = colors.darkBlue;
    icon = <IconPrimitive as={MdInfo} />;
  }

  return (
    <MessagePrimitive
      backgroundColor={backgroundColor}
      className={className}
      withMarginBottom={withMarginBottom}
    >
      {icon}
      {children}
    </MessagePrimitive>
  );
}

Message.types = {
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning'
};

Message.propTypes = {
  /** Custom styles applied to the element */
  className: string,
  /** The message text or component */
  children: node.isRequired,
  /** One of three types of messages */
  type: oneOf(Object.values(Message.types)),
  /** Adds a margin to the bottom of the wrapper */
  withMarginBottom: bool
};

Message.defaultProps = {
  className: '',
  type: Message.types.INFO
};

export default Message;
